import { isProd } from "@/env";

import GoogleTagManager from "./GoogleTagManager";
import Intercom from "./Intercom";
import LogRocket from "./LogRocket";
import MicrosoftClarity from "./MicrosoftClarity";

const Widgets = () => {
  if (process.env.ENV === "localhost") {
    return null;
  }

  return (
    <>
      <GoogleTagManager />
      <Intercom />
      {isProd() && <LogRocket />}
      {/* Skip Clarity on a local dev server (yarn start). ENV=localhost above only
          works if the local .env sets it; NODE_ENV comes from the webpack build. */}
      {process.env.NODE_ENV !== "development" && <MicrosoftClarity />}
    </>
  );
};

export default Widgets;
